import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/config/i18n";
import { scrollToId } from "@/config/site";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Highlights } from "@/components/Highlights";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Consulta } from "@/components/Consulta";
import { Trabalhos } from "@/components/Trabalhos";
import { Pactuacoes } from "@/components/Pactuacoes";
import { Internacional } from "@/components/Internacional";
import { Depoimentos } from "@/components/Depoimentos";
import { ComoFunciona } from "@/components/ComoFunciona";
import { FAQ } from "@/components/FAQ";
import { Sigilo } from "@/components/Sigilo";
import { AvisoLegal } from "@/components/AvisoLegal";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import GoetiaPage from "@/pages/GoetiaPage";
import GoetiaSpiritPage from "@/pages/GoetiaSpiritPage";

const Home = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) setTimeout(() => scrollToId(hash.slice(1)), 150);
  }, [hash]);

  return (
    <main>
      <Hero />
      <Highlights />
      <Marquee />
      <About />
      <Consulta />
      <Trabalhos />
      <Pactuacoes />
      <Internacional />
      <Depoimentos />
      <ComoFunciona />
      <FAQ />
      <Sigilo />
      <AvisoLegal />
      <FinalCTA />
    </main>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App bg-[#0A0A0C] text-[#F7F7F8] min-h-screen">
          <div className="grain-overlay" aria-hidden="true" />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/goetia" element={<GoetiaPage />} />
            <Route path="/goetia/:slug" element={<GoetiaSpiritPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <FloatingWhatsApp />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
